import { render, staticRenderFns } from "./IntakeView.vue?vue&type=template&id=204f69aa"
import script from "./IntakeView.vue?vue&type=script&lang=js"
export * from "./IntakeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports